<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    
  },
  watch: {
    $route: function (val) {
      // 判断环境为移动端时跳转到移动端
      console.log("路由变化", val);

      const devices = navigator.userAgent;

      if (
        /Android|webOS|iPhone|iPad|Windows Phone|iPod|BlackBerry|SymbianOS|Nokia|Mobile/i.test(
          devices
        )
      ) {
        let afterUrl = location.protocol + "//" + location.host + "/#/";
        setTimeout(() => {
          location.href =
            afterUrl + (val.query.catid ? "?catId=" + val.query.catid : "");
          // location.href = 'http://localhost:8081/#/' + (val.query.catid ? '?catId=' + val.query.catid : '')
        }, 100);
      }
    },
  },
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
  background-color: #fefbff;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html,
body,
#app {
  height: 100%;
}
</style>
